module.exports = __webpack_public_path__ + "img/plus2.cd574222.png";